import { FeatureFlags } from './feature-flags';

export * from './mock-feature-flags';
export * from './feature-flags';

export default FeatureFlags;
